<div class="flex items-center justify-between">
  <div class="text-lg font-medium text-white mx-auto">{{data.messaggio}}</div>
  <!-- <div class="dismiss">
      <button mat-icon-button (click)="sbRef.dismiss()"  [matTooltip]="'Chiudi'" [color]="'accent'">
        <mat-icon class="icon-size-5 text-gr" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
    </div> -->
</div>

<!-- <ul class="dropdown-menu inner show">
  <li class="selected active"><a role="option" class="dropdown-item selected active" aria-disabled="false" tabindex="0"
      aria-selected="true"><span class="text"></span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Titolare</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Studio associato</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Socio</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Professionista incaricato</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Notaio</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Liquidatore</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Legale_rappresentante</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Delegato</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Curatore fallimentare</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Consulente</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Commissario giudiziario</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Centro elaborazione dati</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Associazione di categoria</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Amministratore</span></a></li>
  <li><a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false"><span
        class="text">Altro previsto dalla vigente normativa</span></a></li>
</ul> -->